import script from "./PlIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PlIcon.vue?vue&type=script&setup=true&lang=js"

import "./PlIcon.vue?vue&type=style&index=0&id=56c6eb96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c6eb96"]])

export default __exports__